import axiosInstance from "@/lib/axiosInstance";

const getDashboardCounts = async () => {
  try {
    const { data: response } = await axiosInstance.get("/api/admin/counts");
    return response;
  } catch (error) {
    throw error;
  }
};

const getTaskTimeSeries = async ({ unit }: { unit: string }) => {
  try {
    const { data: response } = await axiosInstance.get(
      "/api/admin/taskTimeseries",
      {
        params: {
          unit,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
const getTasksData = async ({
  page,
  limit,
  search,
  status,
  propertyId,
  vendor,
  startDate,
  endDate,
}: any) => {
  try {
    const { data: response } = await axiosInstance.get("/api/tasks", {
      params: {
        page: page + 1,
        limit,
        search,
        status,
        propertyId,
        vendor,
        startDate,
        endDate,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const getTaskById = async (id: any) => {
  try {
    const { data: response } = await axiosInstance.get(`/api/tasks/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const deleteTaskData = async (id: any) => {
  try {
    const { data: response } = await axiosInstance.delete(`/api/tasks/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getVendorsData = async ({
  page,
  limit,
  search,
  active,
  specialties,
}: any) => {
  try {
    const { data: response } = await axiosInstance.get("/api/vendors", {
      params: {
        page: page + 1,
        limit,
        search,
        active,
        specialties,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const getVendorById = async (id: any) => {
  try {
    const { data: response } = await axiosInstance.get(`/api/vendors/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getPropertyData = async ({ filters, page, rowsPerPage }: any) => {
  try {
    const params = new URLSearchParams({
      ...Object.fromEntries(
        Object.entries(filters).filter(
          ([_, value]) => value !== undefined && value !== ""
        )
      ),
      limit: rowsPerPage.toString(),
      page: (page + 1).toString(),
    });
    const { data: response } = await axiosInstance.get(
      `/api/properties?${new URLSearchParams(params)}`
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};

const getPropertyById = async (id: any) => {
  try {
    const { data: response } = await axiosInstance.get(`/api/properties/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getResidentData = async ({ filters, page, rowsPerPage }: any) => {
  try {
    const params = new URLSearchParams({
      ...Object.fromEntries(
        Object.entries(filters).filter(
          ([_, value]) => value !== undefined && value !== ""
        )
      ),
      limit: rowsPerPage.toString(),
      page: (page + 1).toString(),
    });
    const { data: response } = await axiosInstance.get(
      `/api/residents?${new URLSearchParams(params)}`
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};

export type Message = {
  _id: string;
  threadId?: string;
  fromUser: string;
  toUsers: string[];
  body: string;
  type?: 'text'|'announcement'|'system';
  readBy?: string[];
  createdAt: string;
};

export type Paged<T> = {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
  data: T[];
};

export async function listMessages(params: {
  page?: number; limit?: number; user?: string; threadId?: string; type?: string; search?: string
}) {
  const { data } = await axiosInstance.get<Paged<Message>>('/api/messages', { params });
  return data;
}
export async function createMessage(payload: Partial<Message>) {
  const { data } = await axiosInstance.post<Message>('/api/messages', payload);
  return data;
}
export async function updateMessage(id: string, payload: Partial<Message>) {
  const { data } = await axiosInstance.put<Message>(`/api/messages/${id}`, payload);
  return data;
}
export async function deleteMessage(id: string) {
  const { data } = await axiosInstance.delete<{deleted:boolean;id:string}>(`/api/messages/${id}`);
  return data;
}
export async function markRead(id: string, user: string) {
  const { data } = await axiosInstance.post<Message>(`/api/messages/${id}/mark-read`, { user });
  return data;
}
export async function unreadCount(user: string) {
  const { data } = await axiosInstance.get<{user:string;unread:number}>(`/api/messages/derived/unread-count`, { params: { user } });
  return data.unread;
}

export const getMeetingsData = async ({ page, limit, search }: any) => {
  try {
    const { data: response } = await axiosInstance.get("/api/meetings", {
      params: {
        page: page + 1,
        limit,
        search,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
}

export {
  getDashboardCounts,
  getTaskTimeSeries,
  getTasksData,
  getTaskById,
  deleteTaskData,
  getVendorsData,
  getPropertyData,
  getPropertyById,
  getVendorById,
  getResidentData,
};
